import { pathgen } from 'object-path-generator';
export const PdfViewerTestIds = pathgen('PdfViewerTestIds');
export const getPdfWorkerSrc = (publicPath)=>{
    const base = publicPath.endsWith('/') ? publicPath : "".concat(publicPath, "/");
    return "".concat(base, "pdf.worker.min.js");
};
